import { animate, group, query, stagger, style, transition, trigger } from '@angular/animations';

// More subtle route animations that don't interfere with component animations
export const slideInAnimation = trigger('routeAnimations', [
  // For transitions involving the intro screen, avoid absolute positioning to prevent layout jumps
  transition('intro <=> *', [
    group([
      query(
        ':leave',
        [
          animate(
            '300ms ease-out',
            style({
              opacity: 0,
            })
          ),
        ],
        { optional: true }
      ),

      query(
        ':enter',
        [
          style({
            opacity: 0,
          }),
          animate(
            '400ms 100ms ease-out',
            style({
              opacity: 1,
            })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),

  transition('* <=> *', [
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }),
      ],
      { optional: true }
    ),

    group([
      query(
        ':leave',
        [
          animate(
            '300ms ease-out',
            style({
              opacity: 0,
            })
          ),
        ],
        { optional: true }
      ),

      query(
        ':enter',
        [
          style({
            opacity: 0,
          }),
          animate(
            '400ms 100ms ease-out',
            style({
              opacity: 1,
            })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
]);

// Fade animation for elements within components
export const fadeAnimation = trigger('fadeAnimation', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('400ms 150ms ease-out', style({ opacity: 1 })),
  ]),
  transition(':leave', [animate('200ms ease-out', style({ opacity: 0 }))]),
]);

// Enhanced staggered entry animation for lists (like quiz options)
export const listAnimation = trigger('listAnimation', [
  transition('* => *', [
    query(':enter', style({ opacity: 0, transform: 'translateY(25px)' }), { optional: true }),
    query(
      ':enter',
      stagger('150ms', [
        animate(
          '450ms cubic-bezier(0.35, 0, 0.25, 1)',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
      { optional: true }
    ),
  ]),
]);
